import React, { createContext, useReducer } from 'react'

export const SET_MODULES_DATA = 'SET_MODULES_DATA'
export const UPDATE_CHANGE_MODULES_DATA = 'UPDATE_CHANGE_MODULES_DATA'
export const SET_SELECTED_MODULES_DATA = 'SET_SELECTED_MODULES_DATA'

export const SET_SHOW_HIDE_MODULE_POPUP = 'SET_SHOW_HIDE_MODULE_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_MODULES_DATA: {
      return { ...data, data: payload.data }
    }
    case UPDATE_CHANGE_MODULES_DATA: {
      let tempData = [...data.data]
      tempData[payload.data.index] = payload.data
      return {
        ...data,
        data: tempData,
        showModulesFormPopup: false,
        selectedObject: {},
      }
    }
    case SET_SELECTED_MODULES_DATA: {
      return {
        ...data,
        selectedObject: payload.data,
        showModulesFormPopup: true,
      }
    }
    case SET_SHOW_HIDE_MODULE_POPUP: {
      if (payload.data) {
        return { ...data, showModulesFormPopup: payload.data }
      } else {
        return {
          ...data,
          showModulesFormPopup: payload.data,
          selectedObject: {},
        }
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: { data: [], pagination: {} },
  selectedObject: {},
  showModulesFormPopup: false,
}

const ModulesStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <ModulesContext.Provider value={[state, dispatch]}>
      {children}
    </ModulesContext.Provider>
  )
}

export const ModulesContext = createContext(initialState)
export default ModulesStore
